import { YANDEX_CAPTCHA_LANGS } from '../constants.js';

/**
 * @module yandex-captcha/getDefaultCaptchaParams
 * @description
 * Функция для получения параметров рендера Yandex Captcha для UI компонентов в CommonJS (быстрый заказ, обратная связь, отзывы, комменты к статьям).
 *
 * @param {HTMLElement} captchaBlock - DOM-элемент, в котором будет рендериться капча.
 * @returns {Object} Параметры рендера Yandex Captcha.
 */
export default (captchaBlock) => {
  const currentLang = YANDEX_CAPTCHA_LANGS[window.Shop.config.get('locale').locale] || 'ru';

  const renderParams = {
    // sitekey — ключ клиентской части.
    sitekey: window.Shop.config.get('yandex_captcha_key').yandex_captcha_key,
    // hl — язык виджета.
    hl: currentLang,
    // invisible — невидимая капча.
    invisible: false
  };

  const {
    test,
    webview,
    yandexCaptchaType,
    shieldPosition,
    hideShield
  } = captchaBlock.dataset;

  // test — включение работы капчи в режиме тестирования. Пользователь всегда будет получать задание. Используйте это свойство только для отладки и тестирования.
  if (test === 'true') {
    renderParams.test = true;
  }

  // webview — запуск капчи в WebView. Используется для повышения точности оценки пользователей при добавлении капчи в мобильные приложения с помощью WebView.
  if (webview === 'true') {
    renderParams.webview = true;
  }

  if (yandexCaptchaType === 'invisible') {
    renderParams.invisible = true;

    // shieldPosition — расположение блока с уведомлением об обработке данных.
    if (!shieldPosition) {
      renderParams.shieldPosition = 'bottom-right';
    }

    // hideShield — скрывать с уведомлением об обработке данных. По умолчанию true.
    if (hideShield === 'true') {
      renderParams.hideShield = true;
    }
  }

  return renderParams;
};

